/**
 * shadcn/ui standard `cn` helper.
 *
 * Combines clsx for conditional class merging with tailwind-merge to dedupe
 * conflicting Tailwind utility classes (e.g., `px-4 px-6` collapses to `px-6`).
 * Every shadcn component imports `cn` from this path via the
 * `@/shared/lib/utils` alias declared in `components.json`.
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
